// Auto-generated commands for Recordings domain — DO NOT EDIT.

import type { CommandDef } from '@voicedojo/api';
import type { FrameworkLens, Practice, PracticeMode, PronunciationAccent, ReviewFrameRate, SaveReason, SelfReviewCheck, ThinkingLevel, UploadReason } from '../enums.g.js';
import type { DeliveredCue, LivePitchPanelist, SeriesPlan } from '../responses.g.js';
import type { AiReviewId, RecordingId, SeriesId } from '../ids.g.js';

export interface CompleteSelfReviewCheckCommand {
  check: SelfReviewCheck;
  id: RecordingId;
}

export interface CompleteThumbnailUploadCommand {
  objectKey: string;
  contentType: string;
  id: RecordingId;
}

export interface DiscardRecordingCommand {
  id: RecordingId;
}

export interface IssueUploadUrlCommand {
  contentType: string;
  sizeBytes: number;
  reason?: UploadReason;
  id: RecordingId;
}

export interface KeepRecordingInLibraryCommand {
  id: RecordingId;
}

export interface RenameRecordingCommand {
  name: string;
  id: RecordingId;
}

export interface RequestRecordingReviewCommand {
  reviewId: AiReviewId;
  modelKey?: string;
  frame?: ReviewFrameRate;
  frameworks?: FrameworkLens[];
  pronunciation?: PronunciationAccent | null;
  effort?: ThinkingLevel;
  id: RecordingId;
}

export interface RetryRecordingReviewCommand {
  id: RecordingId;
}

export interface SaveRecordingCommand {
  practice: Practice;
  name: string;
  plannedDurationMinutes: number;
  startedAt: string;
  endedAt: string;
  content: unknown;
  cuePlan: DeliveredCue[];
  reason: SaveReason;
  speakerPassage?: string;
  seriesId?: SeriesId | null;
  recordedQuality?: string;
  durationSeconds?: number | null;
  optionalContext?: string;
  seriesDocumentRevision?: number | null;
  deliveredPlanPoints?: number[];
  seriesPlanId?: string | null;
  reviewId?: AiReviewId | null;
  reviewModelKey?: string;
  reviewFrame?: ReviewFrameRate;
  reviewFrameworks?: FrameworkLens[];
  reviewPronunciation?: PronunciationAccent | null;
  reviewEffort?: ThinkingLevel;
  plan?: SeriesPlan;
  mode?: PracticeMode;
  liveConvoModelKey?: string;
  coachFeedback?: string;
  feedbackStartSeconds?: number | null;
  livePitchRoster?: LivePitchPanelist[];
  id: RecordingId;
}

export interface SetRecordingNotesCommand {
  notes: string;
  id: RecordingId;
}

/** CommandDef descriptor for POST /api/command ($type: 'CompleteSelfReviewCheckCommand'). */
export const completeSelfReviewCheck: CommandDef<CompleteSelfReviewCheckCommand> = {
  $type: 'CompleteSelfReviewCheckCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'CompleteThumbnailUploadCommand'). */
export const completeThumbnailUpload: CommandDef<CompleteThumbnailUploadCommand> = {
  $type: 'CompleteThumbnailUploadCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'DiscardRecordingCommand'). */
export const discardRecording: CommandDef<DiscardRecordingCommand> = {
  $type: 'DiscardRecordingCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'IssueUploadUrlCommand'). */
export const issueUploadUrl: CommandDef<IssueUploadUrlCommand> = {
  $type: 'IssueUploadUrlCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'KeepRecordingInLibraryCommand'). */
export const keepRecordingInLibrary: CommandDef<KeepRecordingInLibraryCommand> = {
  $type: 'KeepRecordingInLibraryCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'RenameRecordingCommand'). */
export const renameRecording: CommandDef<RenameRecordingCommand> = {
  $type: 'RenameRecordingCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'RequestRecordingReviewCommand'). */
export const requestRecordingReview: CommandDef<RequestRecordingReviewCommand> = {
  $type: 'RequestRecordingReviewCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'RetryRecordingReviewCommand'). */
export const retryRecordingReview: CommandDef<RetryRecordingReviewCommand> = {
  $type: 'RetryRecordingReviewCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SaveRecordingCommand'). */
export const saveRecording: CommandDef<SaveRecordingCommand> = {
  $type: 'SaveRecordingCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetRecordingNotesCommand'). */
export const setRecordingNotes: CommandDef<SetRecordingNotesCommand> = {
  $type: 'SetRecordingNotesCommand',
};

